export default __webpack_public_path__ + "static/banner-four-shape7-899d39d718e6cf56eef78fc3146d2660.png";